import { FindPortsInput, FindPortsOutput } from "@cruisen/contract"
import { callFirebaseFunction } from "../callFirebaseFunction"

export const fetchDeparturePorts = async () => {
  const response = await callFirebaseFunction({
    name: "departurePorts",
    payload: null,
  })
  if (response.error) return []
  return response.data.portGroups
}

export const fetchDestinationPorts = async (departurePortGroupIds: number[]) => {
  if (departurePortGroupIds.length === 0) return []
  const response = await callFirebaseFunction({
    name: "destinationPorts",
    payload: { departurePortGroupIds },
  })
  if (response.error) return []
  return response.data.regions
}

export const findPorts = async (data: FindPortsInput): Promise<FindPortsOutput> => {
  const response = await callFirebaseFunction({
    name: "findPorts",
    payload: data,
  })

  if (response.error) {
    return {
      departurePortGroups: [],
      destinationRegions: [],
      months: [],
      sailingCount: 0,
    }
  }

  return response.data
}
